// extracted by mini-css-extract-plugin
export var dividerLine = "_3t-0";
export var errorBackground = "_3t-1";